import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Avatar from '@/ui/Avatar'

const Chip = ({ children, className, deletable, onDeleteClick, theme, ...other }) => {
  let hasAvatar = false
  if (React.Children.count(children)) {
    const flatChildren = React.Children.toArray(children)
    const firstChild = flatChildren[0]
    hasAvatar = firstChild && firstChild.type && firstChild.type === Avatar
  }

  const classes = classnames(
    theme.chip,
    {
      [theme.deletable]: !!deletable,
      [theme.avatar]: !!hasAvatar,
    },
    className,
  )

  return (
    <div className={classes} {...other}>
      <Choose>
        <When condition={typeof children === 'string'}>
          <span>{children}</span>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
      <if condition={deletable}>
        <span className={theme.delete} onClick={onDeleteClick}>
          <svg viewBox="0 0 40 40" className={theme.deleteIcon}>
            <path className={theme.deleteX} d="M 12,12 L 28,28 M 28,12 L 12,28" />
          </svg>
        </span>
      </if>
    </div>
  )
}

Chip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  deletable: PropTypes.bool,
  onDeleteClick: PropTypes.func,
}

Chip.defaultProps = {
  className: '',
  deletable: false,
}

export default Chip



// WEBPACK FOOTER //
// ./ui/Chip/Chip.js